import type { ErrorEvent } from '@sentry/react';

// Console messages from libraries that we cannot fix and that are not actionable.
// Unleash: the 60 second poll fails on network blips, VPNs and ad-blockers.
// MUI: the data grid logs this when it renders inside a hidden or collapsed parent.
const IGNORED_CONSOLE_MESSAGE_PREFIXES = [
  'Unleash: unable to fetch feature toggles',
  'MUI: useResizeContainer - The parent DOM element of the data grid has an empty width',
];

// The Sentry console integration stores the console arguments in `extra.arguments`.
// We match on the console message so real "Failed to fetch" errors from our own API calls stay.
export function shouldDropSentryEvent(event: ErrorEvent): boolean {
  if (event.logger !== 'console') {
    return false;
  }
  const args = event.extra?.arguments;
  const message = Array.isArray(args) ? args[0] : undefined;
  return (
    typeof message === 'string' &&
    IGNORED_CONSOLE_MESSAGE_PREFIXES.some((prefix) => message.startsWith(prefix))
  );
}
